// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"f9f48ade","703":"7a21cf54","724":"fcd54fcd","928":"889b1d0d"}[chunkId] + ".chunk.js";
};